import {
  getGeolocationPlatform,
  isNativeMobileGeolocationPlatform,
} from "@/src/modules/core/lib/geolocation-platform";

const MOBILE_BREAKPOINT = 1024;
const MOBILE_MQL = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

export const GEOLOCATION_STALE_MS = 5 * 60 * 1000;
export const GEOLOCATION_VISIBILITY_REFRESH_MS = 5 * 60 * 1000;

/** Short TTL for submit buffer on phones/tablets — GPS must be recent. */
export const WATCH_BUFFER_MAX_AGE_MOBILE_MS = 30 * 1000;
export const WATCH_BUFFER_MAX_AGE_DESKTOP_MS = 30 * 60 * 1000;

export const WATCH_DESKTOP_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  maximumAge: 60_000,
  timeout: 20_000,
};

export const WATCH_MOBILE_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 30_000,
  timeout: 20_000,
};

/** iOS cold-start GPS can be slow indoors — slightly longer than Android. */
export const WATCH_IOS_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 15_000,
  timeout: 25_000,
};

export const SUBMIT_DESKTOP_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  maximumAge: 0,
  timeout: 12_000,
};

export const SUBMIT_MOBILE_HIGH_ACCURACY_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 22_000,
};

export const SUBMIT_MOBILE_COARSE_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  maximumAge: 0,
  timeout: 10_000,
};

export const SUBMIT_IOS_HIGH_ACCURACY_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: 30_000,
};

/** UI layout only — do not use for GPS acquisition strategy. */
export function isMobileViewport(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia(MOBILE_MQL).matches;
}

export function isWatchBufferOnMobileDevice(): boolean {
  return isNativeMobileGeolocationPlatform();
}

export function getWatchPositionOptions(): PositionOptions {
  if (getGeolocationPlatform() === "ios") {
    return WATCH_IOS_OPTIONS;
  }
  if (isNativeMobileGeolocationPlatform()) {
    return WATCH_MOBILE_OPTIONS;
  }
  return WATCH_DESKTOP_OPTIONS;
}

export function getSubmitHighAccuracyOptions(): PositionOptions {
  if (getGeolocationPlatform() === "ios") {
    return SUBMIT_IOS_HIGH_ACCURACY_OPTIONS;
  }
  if (isNativeMobileGeolocationPlatform()) {
    return SUBMIT_MOBILE_HIGH_ACCURACY_OPTIONS;
  }
  return SUBMIT_DESKTOP_OPTIONS;
}

/** Sheet open gate on mobile — high accuracy so the session fix matches submit precision. */
export function getSheetOpenProbeOptions(timeoutMs: number): PositionOptions {
  if (isNativeMobileGeolocationPlatform()) {
    return {
      ...getSubmitHighAccuracyOptions(),
      maximumAge: 0,
      timeout: timeoutMs,
    };
  }

  return {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: timeoutMs,
  };
}
